import React from 'react';
import { motion } from 'framer-motion';
import Slider from '../common/Slider';

// Import local images from your list
import fitneseqp12 from '../../assets/images/fitneseqp12.png';
import saunaPic from '../../assets/images/sauna pic.png';
import steamRoom from '../../assets/images/steam room.png';
import pcfStudioOut from '../../assets/images/pcf studio out.png';

const HeroSlider = () => {
  const slides = [
    {
      image: fitneseqp12,
      badge: "PREMIUM FITNESS",
      title: "EXPLORE OUR GYM",
      description: "Experience state-of-the-art equipment, expert trainers, and a community that pushes you to be your absolute best.",
      cta: {
        text: "Explore Gym",
        link: "/services/gym"
      }
    },
    {
      image: saunaPic,
      badge: "WELLNESS",
      title: "INFRARED SAUNA THERAPY",
      description: "Detoxify, relax, and accelerate recovery in our premium infrared sauna. The ultimate post-workout experience.",
      cta: {
        text: "Book Sauna",
        link: "/services/sauna"
      }
    },
    {
      image: steamRoom,
      badge: "REJUVENATE",
      title: "STEAM ROOM ESCAPE",
      description: "Open your pores, improve circulation, and melt away stress in our luxurious steam room. Pure relaxation awaits.",
      cta: {
        text: "Experience Steam",
        link: "/services/steam"
      }
    },
    {
      image: pcfStudioOut,
      badge: "MINDFULNESS",
      title: "PCF STUDIO FOR CLASSES",
      description: "Challenge your body and calm your mind in our dedicated PCF studio. Perfect for all levels, from beginner to advanced.",
      cta: {
        text: "View Classes",
        link: "/classes"
      }
    }
  ];

  return (
    <div className="relative w-full" style={{ height: 'clamp(280px, 55vw, 500px)' }}>
      <Slider slides={slides} autoPlay={true} interval={6000} />
    </div>
  );
};

export default HeroSlider;